import './AnimationText.scss'
import styled from "styled-components";
import React from "react";

const HeroesStyles = styled.div`
  span {
    color: white;
    font-weight: 600;
    z-index: 1;
  }

  @media only screen and (max-width: 768px) {
    span {
      font-size: 63px;
    }
  }

  @media only screen and (max-width: 428px) {
    span {
      font-size: 60px;
    }
  }

  @media only screen and (max-width: 425px) {
    span {
      font-size: 56px;
    }
  }
  @media only screen and (max-width: 414px) {
    span {
      font-size: 55px;
    }
  }
  @media only screen and (max-width: 393px) {
    span {
      font-size: 55px;
    }
  }
  @media only screen and (max-width: 384px) {
    span {
      font-size: 54px;
    }
  }

  @media only screen and (max-width: 375px) {
    span {
      font-size: 45px;
    }
  }
  @media only screen and (max-width: 360px) {
    span {
      font-size: 45px;
    }
  }
  @media only screen and (max-width: 320px) {
    span {
      font-size: 45px;
    }
  }
`
export const AnimationText = ({letterClass, strArray, idx}) => {
    return (
        <HeroesStyles>
            {strArray.map((char, i) => (
                <span key={char + i} className={`${letterClass} _${i + idx}`}>
          {char}
        </span>
            ))}
        </HeroesStyles>
    )
}


export const AnimatedTextLatter = ({letterClass, strArray, idx}) => {
    return (
        <HeroesStyles>
            {Array.from(strArray).map((char, i) => (
                <h2 key={char + i} className={`${letterClass} _${i + idx}`}>
                    {char}
                </h2>
            ))}
        </HeroesStyles>
    )
}
